import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../context/ThemeContext";
import { fetchHosts } from "../../api/host.api"; // ✅ Import from your API file

const Hosts = () => {
  const { background } = useContext(ThemeContext);
  const [hosts, setHosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(9); // You can adjust items per page
  const [hasMore, setHasMore] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const navigate = useNavigate();

  /* ----------------------------- Fetch Hosts ----------------------------- */
  const loadHosts = async (pageNumber = 1, query = "") => {
    try {
      if (pageNumber === 1) setLoading(true);
      else setIsLoadingMore(true);

      const data = await fetchHosts(query, pageNumber, limit);
      console.log("🚀 ~ loadHosts ~ data:", data)

      if (pageNumber === 1) setHosts(data.hosts || data); // first load
      else setHosts((prev) => [...prev, ...(data.results || data)]);

      setHasMore(data.hasNextPage || (data.results?.length || 0) === limit);
    } catch (error) {
      console.error("Error fetching hosts:", error);
    } finally {
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  /* ----------------------------- Initial Fetch ----------------------------- */
  useEffect(() => {
    loadHosts(1, search);
  }, [search]);

  /* ----------------------------- Handlers ----------------------------- */
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleHostClick = (id) => {
    navigate(`/hosts/${id}`);
  };

  const loadNextPage = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    setPage(nextPage);
    loadHosts(nextPage, search);
  };

  /* ----------------------------- Render ----------------------------- */
  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header pb-0 border-0 flex-wrap d-flex justify-content-between align-items-center">
              <h4 className="fs-20 mb-3">Hosts (Page {page})</h4>

              <div className="d-flex align-items-center gap-2">
                <input
                  type="text"
                  placeholder="Search by name or phone..."
                  value={search}
                  onChange={handleSearchChange}
                  className="form-control"
                  style={{
                    width: "250px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                  }}
                />

                <button
                  className="btn btn-primary"
                  style={{
                    fontSize: "14px",
                    borderRadius: "5px",
                    padding: "6px 14px",
                  }}
                  onClick={() => (window.location.href = "/hosts/create")}
                >
                  Create
                </button>
              </div>
            </div>

            <div className="card-body">
              {loading ? (
                <div className="text-center text-primary w-100">
                  Loading hosts...
                </div>
              ) : hosts.length === 0 ? (
                <div className="text-center text-gray-500 fs-14">
                  No hosts found
                </div>
              ) : (
                <div className="row">
                  {hosts.map((host) => (
                    <div key={host._id} className="col-xl-4 col-lg-6 col-md-6">
                      <div
                        className="card mb-3 border-0 shadow-sm hover-shadow"
                        onClick={() => handleHostClick(host._id)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="card-body">
                          <div className="d-flex align-items-center mb-3">
                            <div
                              className="me-3 bg-light rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: "60px", height: "60px" }}
                            >
                              <i className="fas fa-user text-primary fs-24"></i>
                            </div>
                            <div>
                              <h5 className="fs-16 mb-1 text-primary">
                                {host.companyName}
                              </h5>
                              <span className="text-secondary fs-14">
                                {host.primaryEmail}
                              </span>
                            </div>
                          </div>

                          <div className="d-flex justify-content-between">
                            <div className="text-secondary fs-12">
                              <i className="fas fa-phone me-2"></i>
                              {host.primaryPhone || "No phone"}
                            </div>
                            <div className="text-secondary fs-12">
                              <i className="fas fa-globe me-2"></i>
                              {host.domain || "N/A"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Pagination Controls */}
      <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
        <button
          onClick={loadNextPage}
          disabled={!hasMore || isLoadingMore}
          style={{
            padding: "10px 20px",
            backgroundColor: !hasMore ? "#ccc" : "dodgerblue",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: !hasMore ? "not-allowed" : "pointer",
          }}
        >
          {isLoadingMore ? "Loading..." : "Next Page"}
        </button>
      </div>
    </>
  );
};

export default Hosts;
